import * as $ from 'jquery';
import Debouncer from '../../lib/Debouncer';
// import { Analytics } from '@plaudit/analytics';

export default class CollapsableGroup {
	private $wrapper: JQuery = $('.collapsableGroup');
	private className_item: string = 'collapsableItem';
	private selector_triggers: string = '.collapsableItem__label';
	private selector_targets: string = '.collapsableItem__content';

	toggleItem(element: Element, force?: boolean): void {
		const $element = $(element);
		const isOpen = $element.parent().hasClass('target');

		if (!isOpen) {
			// this.analytics.trackEvent('Accordion', 'Expand');
		}
		if (isOpen){
			$element.parent().removeClass('target');
			$element.next().stop(true).slideUp();
		} else {
			$element.parent().addClass('target');
			$element.next().stop(true).slideDown();
		}
	}
	toggleItemTargeted(): void {
		let id = (window.location.hash).replace('/', '').replace(/([\.\:])/, '\\$1');
		const $targetedElement = this.$wrapper.find(id.toString());
		if ($targetedElement.hasClass(this.className_item)) {
			this.toggleItem($targetedElement.find(this.selector_triggers).get(0));
		}
	}
	setupEventHandlers(): void {
		this.$wrapper.on('click', this.selector_triggers, (event: JQueryMouseEventObject) => {
			event.preventDefault();
			history.replaceState(undefined, undefined, location.pathname + "#" + event.currentTarget.parentElement.id);
			this.toggleItem(event.currentTarget);
		});
	}

	constructor() {
		if (!this.$wrapper) {
			return;
		}
		// this.analytics = Analytics.getInstance();
		this.setupEventHandlers();
		this.$wrapper.addClass('js-ready');

		let that = this;
		let goo = () => {
			this.$wrapper.find(this.selector_triggers).siblings(this.selector_targets).slideUp(0);
		};
		$.when(goo()).done(() => {
			this.toggleItemTargeted();
		});
	}
}
